import React, { useEffect, useState, useRef, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Navbar, Nav, Form, InputGroup } from "react-bootstrap";
import { useSelector } from "react-redux";
import useSidebar from "../../hooks/useSidebar.js";
import NavbarUser from "./NavbarUser.js";
import useAppDispatch from "../../hooks/useAppDispatch.js";
import { setTitleEvent, selectEvents } from "../../redux/slices/events.js";

const NavbarComponent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const { isOpen, setIsOpen } = useSidebar();
  const [navSearch, setNavSearch] = useState("");
  const timeoutRef = useRef(null);

  const eventsState = useSelector(selectEvents);

  // Sync the search input with the Redux filter on mount (important for
  // restoring from localStorage — the input would otherwise appear blank
  // while a title filter is already applied).
  useEffect(() => {
    setNavSearch(eventsState.setTitleEvent || "");
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Function to execute search and navigation
  const executeSearch = useCallback((searchTerm) => {
    // Redirect to events page if not already there
    if (location.pathname !== "/" && location.pathname !== "/eventos") {
      navigate("/");
      // Defer dispatch to ensure navigation processes first and we don't get stuck
      setTimeout(() => {
        dispatch(setTitleEvent(searchTerm));
      }, 100);
    } else {
      dispatch(setTitleEvent(searchTerm));
    }
  }, [dispatch, location.pathname, navigate]);

  // Debounced search with locking mechanism
  const debouncedSearch = useCallback((searchTerm) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }

    timeoutRef.current = setTimeout(() => {
      executeSearch(searchTerm);
    }, 350);
  }, [executeSearch]);

  // Handle search from input change
  const handleSearch = useCallback((value) => {
    setNavSearch(value);
    debouncedSearch(value);
  }, [debouncedSearch]);

  // Clear search when navigating away from home
  useEffect(() => {
    if (location.pathname !== "/" && location.pathname !== "/eventos") {
      setNavSearch("");
      dispatch(setTitleEvent(""));
    }
  }, [location.pathname, dispatch]);

  return (
    <Navbar variant="light" expand className="navbar-bg">
      <span
        className="sidebar-toggle d-flex"
        onClick={() => {
          setIsOpen(!isOpen);
        }}
      >
        <i className="hamburger align-self-center" />
      </span>
      <Form inline="true" onSubmit={(event) => event.preventDefault()} className="d-inline-block">
        <InputGroup className="input-group-navbar">
          <Form.Control
            type="text"
            value={navSearch}
            placeholder={'Procurar eventos...'}
            aria-label="Search"
            onChange={(e) => {
              const value = e.target.value;
              handleSearch(value, false);
            }}
          />
        </InputGroup>
      </Form>
      <Navbar.Collapse>
        <Nav className="navbar-align">
          <NavbarUser />
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default NavbarComponent;